import { styled } from 'stitches.config'

export const AllProductsRoot = styled('div', {
    width: '100%',
    background: '$accent-white',
})